import React, { useState, useEffect } from 'react';
import { FiMessageCircle, FiX, FiSend } from 'react-icons/fi';
import { chatbotService } from '../../services';
import './Chatbot.css';

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');

  useEffect(() => {
    if (messages.length === 0) {
      setMessages([{
        id: 1,
        text: "Hello! Bonjour! 👋 I am the S2i expert. How can I help you today? / Je suis l'expert S2i. Comment puis-je vous aider ?",
        isBot: true
      }]);
    }
  }, []);

  const handleSend = async () => {
    if (!input.trim()) return;
    const userMsg = { id: Date.now(), text: input, isBot: false };
    setMessages(prev => [...prev, userMsg]);
    const textToSend = input;
    setInput('');

    try {
      const res = await chatbotService.sendMessage(textToSend);
      setMessages(prev => [...prev, { id: Date.now()+1, text: res.response || res.reply, isBot: true }]);
    } catch (e) {
      setMessages(prev => [...prev, { id: Date.now()+2, text: "Technical error / Erreur technique.", isBot: true }]);
    }
  };

  return (
    <>
      {/* LE BOUTON ROND ROUGE (Bulle) */}
      <button className="chatbot-toggle" onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? <FiX size={30} /> : <FiMessageCircle size={30} />}
      </button>

      {/* LA FENÊTRE (S'affiche si isOpen est vrai) */}
      {isOpen && (
        <div className="chatbot-window">
          <div className="chatbot-header">Assistant S2i</div>
          <div className="chatbot-messages">
            {messages.map(m => (
              <div key={m.id} className={`chat-message ${m.isBot ? 'bot' : 'user'}`}>
                <div className="message-bubble">{m.text}</div>
              </div>
            ))}
          </div>
          <div className="chatbot-input">
            <textarea
  value={input}
  onChange={(e) => setInput(e.target.value)}
  onKeyDown={(e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault(); // Empêche le retour à la ligne
      handleSend();       // Lance l'envoi
    }
  }}
  placeholder="Type here..."
/>            <button className="send-button" onClick={handleSend}><FiSend /></button>
          </div>
        </div>
      )}
    </>
  );
};

export default Chatbot;